import { useState, useMemo, useCallback } from "react";
import { motion } from "framer-motion";
import Image from "next/image";
import Link from "next/link";
import { useLocale, useTranslations } from "next-intl";
import { MdClear } from "react-icons/md";
import { HiMenu } from "react-icons/hi";
import cls from "./MobileHeader.module.scss";
import { useSignUpModal } from "@/states/ui.state";
import { helpCenterLink } from "@/constant";
import GlobalStyle from "../GlobalStyle/GlobalStyle";
import cn from "classnames";
import { useRouter } from "next/router";
interface MobileHeaderProps {
  main?: boolean;
}
const MobileHeader: React.FC<MobileHeaderProps> = ({
  main = true
}) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const {
    isSignUpModal
  } = useSignUpModal();
  const locale = useLocale();
  const t = useTranslations("Header");
  const t2 = useTranslations("Footer");
  const router = useRouter();
  const logoSrc = useMemo(() => {
    const logoMap: Record<string, string> = {
      nl: "/common/main/logo-nl.svg",
      default: "/common/main/logo.svg"
    };
    return main ? logoMap[locale] || logoMap.default : `/common/qrfast/logo.svg`;
  }, [main, locale]);
  const toggleDrawer = useCallback(() => setIsDrawerOpen(prev => !prev), []);
  const renderLogo = () => <Image className={cn(cls.mobile_header_logo, {
    [cls.fast_mobile_header_logo]: !main
  })} priority src={logoSrc} alt={t("logoAlt") || "qr generator"} width={224} height={28} data-sentry-element="Image" data-sentry-component="renderLogo" data-sentry-source-file="MobileHeader.tsx" />;
  const DrawerLinks = () => <div className={cls.drawer_links} data-sentry-component="DrawerLinks" data-sentry-source-file="MobileHeader.tsx">
      {main && <>
          <Link href="/about">{t2("aboutUs")}</Link>
          <Link href="/contact">{t2("contactUs")}</Link>
          <Link href={helpCenterLink} target="_blank">{t2("helpCenter")}</Link>
        </>}
      <Link href="/terms" className={main ? "" : cls.__link} data-sentry-element="Link" data-sentry-source-file="MobileHeader.tsx">{t2("termsConditions")}</Link>
      <Link href="/policy" className={main ? "" : cls.__link} data-sentry-element="Link" data-sentry-source-file="MobileHeader.tsx">{t2("privacy")}</Link>
    </div>;
  const DrawerFooter = () =>
  //FIXED ME for other copy sites
  <div className={cn(cls.drawer_footer, {
    [cls.fast_drawer_footer]: !main
  })} data-sentry-component="DrawerFooter" data-sentry-source-file="MobileHeader.tsx">
      <Link className={cls.__login} href="/login" data-sentry-element="Link" data-sentry-source-file="MobileHeader.tsx">{t("login")}</Link>
      <Link className={cls.__signup} href="/register" data-sentry-element="Link" data-sentry-source-file="MobileHeader.tsx">{t("signUp")}</Link>
    </div>;
  const navigateToHome = useCallback(() => {
    if (router.pathname !== "/") {
      router.push("/");
    }
  }, [router]);
  return <>
      <div className={cn(cls.mobile_header, cls)}>
        <span onClick={navigateToHome} style={{
        cursor: router.pathname === "/" ? "unset" : "pointer"
      }}>
          {renderLogo()}
        </span>
        {isDrawerOpen ?
      //FIXED ME for other copy sites
      <MdClear color={main ? "#0A9396" : "#aa00fd"} size={32} onClick={toggleDrawer} /> : <HiMenu color={main ? "#0A9396" : "#aa00fd"} size={32} onClick={toggleDrawer} />}
      </div>

      <motion.div initial={{
      y: "-100%"
    }} animate={{
      y: isDrawerOpen ? "0%" : "-100%"
    }} transition={{
      type: "tween",
      duration: 0.5
    }} className={cls.drawer_container} style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: main ? "482px" : "315px",
      backgroundColor: "#fff",
      zIndex: 1001,
      boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
      overflowY: "auto",
      borderBottomLeftRadius: "16px",
      borderBottomRightRadius: "16px"
    }} data-sentry-element="unknown" data-sentry-source-file="MobileHeader.tsx">
        <div className={cls.drawer_content}>
          <DrawerLinks data-sentry-element="DrawerLinks" data-sentry-source-file="MobileHeader.tsx" />
          <hr className={cls.drawer_hr} />
          <DrawerFooter data-sentry-element="DrawerFooter" data-sentry-source-file="MobileHeader.tsx" />
        </div>
      </motion.div>

      {isDrawerOpen && <>
          <GlobalStyle />
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 0.5
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.3
      }} onClick={toggleDrawer} style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 1000
      }} />
        </>}
    </>;
};
export default MobileHeader;